import { render, staticRenderFns } from "./CopilotMessageStepsDiagram.vue?vue&type=template&id=0a37188a"
import script from "./CopilotMessageStepsDiagram.vue?vue&type=script&lang=ts"
export * from "./CopilotMessageStepsDiagram.vue?vue&type=script&lang=ts"
import style0 from "./CopilotMessageStepsDiagram.vue?vue&type=style&index=0&id=0a37188a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports